<template>
  <base-section-layout
    title="电话调查注意事项"
    icon="https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/pdv-www/order/order-interview-notification/section-phone.png"
    tips="电话调查是使馆核实申请人信息的常规方式，请按以下要求回答即可，不必惊慌"
  >
    <div class="tel-list">
      <div
        v-for="(item, index) in interviewData.tel_interview_notes"
        :key="index"
        class="tel-item"
      >
        {{ item }}
      </div>
    </div>
  </base-section-layout>
</template>

<script>
import BaseSectionLayout from './BaseSectionLayout.vue';

export default {
  name: 'SectionTelInterview',
  components: {
    BaseSectionLayout,
  },
  props: {
    interviewData: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang="less" scoped>
.tel-list {
  color: #666;
  font-size: 12px;
  line-height: 21px;
  word-break: break-all;

  .tel-item {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
